import React from 'react';
import { Link } from 'react-router-dom';
import { useAppLink } from '../../utils/link.utils';

const AppLink = ({ to, ...props }) => {
  const link = useAppLink();
  return <Link to={link(to)} {...props} />;
};

export default AppLink;